import { render } from "./LipProfilePage.vue?vue&type=template&id=6b39c376&ts=true"
import script from "./LipProfilePage.vue?vue&type=script&lang=ts"
export * from "./LipProfilePage.vue?vue&type=script&lang=ts"

import "./LipProfilePage.vue?vue&type=style&index=0&id=6b39c376&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__